export default __webpack_public_path__ + "static/media/AMI_T.bc26dc17.png";